"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageMixin = void 0;
var _spacingMixin = require("../spacingMixin");
/** @class ImageMixin */
/** @method */
var ImageMixin = _spacingMixin.spacingMixin;
exports.ImageMixin = ImageMixin;